const eventListEl = document.querySelector('.event-list__row');

if (eventListEl) {
  // Axios get filtered post list
  const axiosGetLoadMoreEvents = async (page, button) => {
    const formDataInput = new FormData();
    formDataInput.append('action', 'getLoadMoreEvents');
    formDataInput.append('page', page);

    const data = {
      action: 'getLoadMoreEvents',
      page,
    };

    try {
      const response = await axios.post(localData.siteURL, data);
      updateList(eventListEl, document.querySelector('.event-list__footer'), response.data.data);
    } catch (err) {
      console.error(err);
    }
    button.disabled = false;
  };

  // Click event for load more button
  attachEvent('.event-list__load-more', 'click', (ev) => {
    ev.preventDefault();
    ev.target.disabled = true;
    axiosGetLoadMoreEvents(parseInt(eventListEl.dataset.page) + 1, ev.target);
  });
}
